import { GzApplicationControlGeneralWebComponent } from './component/GzApplicationControlGeneralWebComponent';

export { GzApplicationControlGeneralWebComponent };
